import {
  SERVICE_DETAILS_2026_BASE,
  SERVICE_DETAILS_2026,
  OPERATION_SERVICE_DETAILS_2026,
} from "./service2026";

/** 얘는 현재 기준으로 판매하는 것만 보여야함 */
const 고이_상품_가격_세자리 = {
  무빈소: SERVICE_DETAILS_2026.무빈소장.가격,
  무빈소장: SERVICE_DETAILS_2026.무빈소장.가격,
  가족장: SERVICE_DETAILS_2026.가족장.가격,
  일반장: SERVICE_DETAILS_2026.일반장.가격,
};

const 고이_상품_가격 = {
  무빈소: SERVICE_DETAILS_2026.무빈소장.가격 * 10_000,
  무빈소장: SERVICE_DETAILS_2026.무빈소장.가격 * 10_000,
  가족장: SERVICE_DETAILS_2026.가족장.가격 * 10_000,
  일반장: SERVICE_DETAILS_2026.일반장.가격 * 10_000,
};

export {
  SERVICE_DETAILS_2026_BASE,
  SERVICE_DETAILS_2026,
  OPERATION_SERVICE_DETAILS_2026,
  고이_상품_가격_세자리,
  고이_상품_가격,
};
